import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentType } from '../../enums/content-type.enum';

export enum InputState {
  Ready = 'Ready',
  Dragging = 'Dragging',
  Loading = 'Loading',
  FileTypeError = 'FileTypeError',
}

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  standalone: false
})
export class FileInputComponent {

  @Input()
  public accept: ContentType[];

  @Output()
  public filesSubmitted = new EventEmitter<File[]>();

  public state: InputState = InputState.Ready;
  public invalidTypes: Set<string>;
  public readonly State = InputState;
  private dragElementsCounter = 0;

  public get acceptTypes(): string {
    return this.accept.join(',');
  }

  public onDragEnter() {
    this.dragElementsCounter++;
    if (this.state === InputState.Ready) {
      this.state = InputState.Dragging;
    }
  }

  public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dataTransferItem = this.getInvalidTypes(event.dataTransfer.items);
    if (dataTransferItem.length > 0) {
      this.state = InputState.FileTypeError;
      this.invalidTypes = new Set<string>(dataTransferItem.map(item => item.type));
    }
  }

  public onDragLeave() {
    this.dragElementsCounter--;
    if (this.dragElementsCounter === 0) {
      this.state = InputState.Ready;
    }
  }

  public onFileInput(event): void {
    const files = event.target.files;
    this.storeFiles(files);
    event.target.value = null;
  }

  public onDrop(event: DragEvent) {
    this.state = InputState.Loading;
    this.dragElementsCounter = 0;
    event.preventDefault();
    event.stopPropagation();
    const fileList = event.dataTransfer.files;
    this.storeFiles(fileList);
    this.state = InputState.Ready;
  }

  private storeFiles(fileList: FileList) {
    const files = [];
    Object.values(fileList)
      .filter(file => this.acceptTypes.includes(file.type))
      .forEach(file => files.push(file));
    if (files.length > 0) {
      this.filesSubmitted.emit(files);
    }
  }

  private getInvalidTypes(items: DataTransferItemList): DataTransferItem[] {
    return Object.values(items).filter(item => !this.acceptTypes.includes(item.type));
  }
}
